import React, { useState, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthContext } from './AutheticationContext';

/**
 * ProtectedRoute component that ensures a user is authenticated
 * before rendering its children
 */
const ProtectedRoute = ({ fallback = null }) => {
  const { isAuthenticated, isLoading, fetchAttempted } = useAuthContext();
  const [validationTimeout, setValidationTimeout] = useState(false);

  // Set a timeout to prevent indefinite loading
  useEffect(() => {
    // Set a timeout to prevent indefinite loading state
    const timeoutId = setTimeout(() => {
      if (isLoading) {
        console.warn('Session validation timed out - proceeding to login');
        setValidationTimeout(true);
      }
    }, 20000); // 20 seconds max wait time
    
    return () => clearTimeout(timeoutId);
  }, [isLoading]);

  // If still loading and not timed out, show the fallback component
  if ((isLoading && !validationTimeout) || (!fetchAttempted && !validationTimeout)) {
    console.log('Validating token with server...');
    return fallback;
  }

  // If validation timed out or user is not authenticated, redirect to login
  if (validationTimeout || !isAuthenticated) {
    console.log(validationTimeout 
      ? 'Session validation timed out - redirecting to login' 
      : 'User not authenticated - redirecting to login');
    return <Navigate to="/login" replace />;
  }

  // User is authenticated, render the protected routes
  return <Outlet />;
};

export default ProtectedRoute;